<template>
  <b-modal
    id="modal-delete"
    :title="'Delete ' + selectedNotes.length + ' ' + noteText + '?'"
  >
    <span class="close" @click="onClose">
      <x-icon size="1.5x" class="custom-class"></x-icon>
    </span>
    <div class="">
      <div class="row">
        <div class="col-6">
          <b-button variant="primary" @click="onDelete">
            Yes, delete them
          </b-button>
        </div>
        <div class="col-6">
          <b-button @click="onClose"> No, take me back </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { XIcon } from "vue-feather-icons";
export default {
  components: {
    XIcon,
  },
  data: function () {
    var obj = {
      lock: false,
      key: "",
      errorMessage: "",
      options: {},
      previewText: "",
      previewHTML: "",
      copyText: "Copy Text",
      copyHTML: "Copy HTML",
      options: {
        removeLinks: false,
      },
    };
    return obj;
  },
  computed: {
    notes: function () {
      return this.$store.getters.notes;
    },
    selectedNotes: function () {
      return this.$store.getters["note/selectedNotes"];
    },
    noteText: function () {
      var len = this.selectedNotes.length;
      var str = "Notes";
      if (len === 1) {
        str = "Note";
      }
      return str;
    },
  },
  methods: {
    onDelete: function () {
      var ids = this.selectedNotes;
      this.$store.dispatch("note/bulkRemoveNotes", ids);
      this.$store.commit("note/CLEAR_SELECTION");
      this.$bvModal.hide("modal-delete");
    },
    onClose: function () {
      this.$bvModal.hide("modal-delete");
    },
    init: function () {},
  },
  mounted: function () {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {});
  },
};
</script>

<style lang="scss">
#modal-delete___BV_modal_outer_ {
  .modal-dialog {
    max-width: 380px;
  }
  .modal-content {
    ul {
      list-style: initial;
    }
    h3 {
      margin-bottom: 1rem;
    }

    .box {
      margin-bottom: 1rem;
      padding: 0.5rem;
      border-radius: 12px;
      background-color: rgba(0, 0, 0, 0.3);
      .btn {
        margin-bottom: 0.25rem;
      }

      p {
        opacity: 0.85;
        font-size: 0.825rem;
        margin-bottom: 0;
      }
    }

    .preview {
      font-size: 14px;
      margin-top: 0.5rem;
      padding: 1rem;
      border-radius: 7px;
      background-color: rgba(0, 0, 0, 0.2);
      font-feature-settings: "case" 0, "cpsp" 0, "dlig" 0, "frac" 0, "dnom" 0,
        "numr" 0, "salt" 0, "subs" 0, "sups" 0, "tnum", "zero" 0, "ss01" 0,
        "ss02" 0, "ss03" 0, "ss04" 0, "cv01" 0, "cv02" 0, "cv03" 0, "cv04" 0,
        "cv05" 0, "cv06" 0, "cv07" 0, "cv08" 0, "cv09" 0, "cv10" 0, "cv11" 0,
        "calt", "kern";

      h3 {
        font-size: 1.35em;
        margin-bottom: 0.5rem;
      }

      em {
        display: inline-block;
        opacity: 0.85;

        p {
          margin-bottom: 0;
        }
      }
    }

    .logo {
      max-width: 200px;
      margin-bottom: 1rem;
    }
    .spinner-border {
      vertical-align: baseline;
      display: inline-block;
      width: 2rem;
      height: 2rem;
      border: 0.25em solid;
      border-right: 0.25em solid transparent;
      border-radius: 50%;
      animation: spinner-border 0.75s linear infinite;
    }
    .spinner-border-sm {
      width: 12px;
      height: 12px;
      border-width: 2px;
    }

    @keyframes spinner-border {
      to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn);
      }
    }
  }
}
</style>
